var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-project-container" },
    [
      _c(
        "DialogSlot",
        {
          ref: "create-project-modal",
          attrs: {
            id: "create-project-modal",
            modalBtn: _vm.showCreateButtonName(),
            modalHeader: _vm.modalHeaderText,
            showCloseBtn: false,
            beforeOpenModal: _vm.beforeOpenCreateProjectModal,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.numberType,
                      expression: "numberType",
                    },
                  ],
                  attrs: {
                    id: "radio_po",
                    type: "radio",
                    name: "radio_po_contract",
                  },
                  domProps: {
                    value: _vm.PROJECT_TYPES.PO,
                    checked: _vm._q(_vm.numberType, _vm.PROJECT_TYPES.PO),
                  },
                  on: {
                    change: function ($event) {
                      _vm.numberType = _vm.PROJECT_TYPES.PO
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "radio_po" } }, [
                  _vm._v(_vm._s(_vm.$t("project.type.po"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.numberType,
                      expression: "numberType",
                    },
                  ],
                  attrs: {
                    id: "radio_contract",
                    type: "radio",
                    name: "radio_po_contract",
                  },
                  domProps: {
                    value: _vm.PROJECT_TYPES.CONTRACT,
                    checked: _vm._q(_vm.numberType, _vm.PROJECT_TYPES.CONTRACT),
                  },
                  on: {
                    change: function ($event) {
                      _vm.numberType = _vm.PROJECT_TYPES.CONTRACT
                    },
                  },
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "radio_contract" } }, [
                  _vm._v(_vm._s(_vm.$t("project.type.contract"))),
                ]),
              ]),
              _vm._v(" "),
              _vm.overAllError
                ? _c("span", { staticClass: "error-hint" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.overAllError) + "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.overAllHint
                ? _c("span", {}, [
                    _vm._v("\n        " + _vm._s(_vm.overAllHint) + "\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.purchaseInputList, function (_, index) {
                return _c("div", { key: index, staticClass: "number-info" }, [
                  _c(
                    "div",
                    { staticClass: "number-info__input" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "fusioninputcheck",
                            rawName: "v-fusioninputcheck",
                            value: _vm.fusionInputCheckOption,
                            expression: "fusionInputCheckOption",
                          },
                        ],
                        staticClass: "number-info__number",
                        class: _vm._errorHighLight(index),
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t(
                            "tender.award.placeholder.number"
                          ),
                          required: "",
                        },
                        domProps: {
                          value: _vm.purchaseInputList[index].number,
                        },
                        on: {
                          change: function (event) {
                            return _vm.inputValue(
                              index,
                              "number",
                              event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.numberType === _vm.PROJECT_TYPES.CONTRACT
                        ? _c("input", {
                            directives: [
                              {
                                name: "fusioninputcheck",
                                rawName: "v-fusioninputcheck",
                                value: _vm.fusionInputCheckOption,
                                expression: "fusionInputCheckOption",
                              },
                            ],
                            staticClass: "number-info__revision",
                            class: _vm._errorHighLight(index),
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "tender.award.placeholder.revision"
                              ),
                              required: "",
                            },
                            domProps: {
                              value: _vm.purchaseInputList[index].revisionNum,
                            },
                            on: {
                              change: function (event) {
                                return _vm.inputValue(
                                  index,
                                  "revisionNum",
                                  event.target.value
                                )
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.numberType === _vm.PROJECT_TYPES.CONTRACT
                        ? _c("HKLSelect", {
                            staticClass: "small-2 medium-2 large-2 columns",
                            class: _vm._errorHighLight(index),
                            attrs: {
                              disabled:
                                _vm.singleNumberInput && _vm.isTenderAward,
                              options: _vm.siteHklOptions,
                              placeholder: _vm.$t(
                                "tender.award.placeholder.siteId"
                              ),
                              showSearch: true,
                              value:
                                _vm.purchaseInputList[index].siteId ||
                                undefined,
                              required: "",
                            },
                            on: {
                              change: function (val) {
                                return (_vm.purchaseInputList[index].siteId =
                                  val)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isTenderAward
                        ? _c("div", { staticClass: "number-info__btn" }, [
                            !index
                              ? _c("i", {
                                  staticClass: "fa-plus fa",
                                  on: {
                                    click: function () {
                                      return _vm.addNumber()
                                    },
                                  },
                                })
                              : _c("i", {
                                  staticClass: "fa-times fa",
                                  on: {
                                    click: function () {
                                      return _vm.removeNumber(index)
                                    },
                                  },
                                }),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "number-info__hint" }, [
                    _vm.inputError[_vm.getErrorKeyFromIndex(index)]
                      ? _c("span", { staticClass: "error-hint" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.inputError[_vm.getErrorKeyFromIndex(index)]
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm.errorMap[_vm.getErrorKeyFromIndex(index)]
                      ? _c("span", { staticClass: "error-hint" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.errorMap[_vm.getErrorKeyFromIndex(index)]
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.closeProjectModal()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--orange",
                attrs: { type: "button", "data-reveal-id": "po-data-modal" },
                on: { click: _vm.addNumbers },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.continue")) + "\n      "
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "DialogSlot",
        {
          ref: "po-data-modal",
          attrs: {
            id: "po-data-modal",
            modalHeader: _vm.$t("hint.whatWeFound"),
            showCloseBtn: false,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("div", { staticClass: "po-info-header-text" }, [
                _vm._v("\n        " + _vm._s(_vm.companyName) + "\n      "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "po-info-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("project.purchaseOrder.totalAmount")) +
                    ": " +
                    _vm._s(
                      _vm._f("formatCurrency")(_vm.totalAmount, {
                        currencyCode: _vm.currencyCode,
                      })
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.items, function (purchaseOrder, index) {
                return _c("PurchaseOrderPreview", {
                  key: index,
                  attrs: {
                    isTenderAward: _vm.isTenderAward,
                    type: _vm.numberType,
                    purchaseOrder: purchaseOrder,
                  },
                  on: {
                    "createProject:updateAttachments": _vm.updateAttachments,
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--darkblue",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.goBackCreateProjectModal()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("action.goback")) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.isTenderAward
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { type: "button", disabled: !_vm.allowAwardTender },
                    on: {
                      click: function ($event) {
                        return _vm.awardTender()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.yesAward")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.enableProjectFeature && !_vm.isTenderAward
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.createProjectWithPoData()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.yesThatsit")) +
                        "\n      "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "DialogSlot",
        {
          ref: "award-tender-success-modal",
          attrs: {
            id: "award-tender-success-modal",
            afterCloseModal: _vm.refreshTender,
            showCloseBtn: false,
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", { class: ["content-text", "font-bold"] }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("tender.awardSuccess")))]),
              _vm._v(" "),
              _vm.showCreateProjectHint()
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("tender.createProjectHint"))),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.showCreateProjectHint()
            ? _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeAwardSuccessModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("action.notNow")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.enableProjectFeature
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--orange",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.createProjectWithPoData()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("action.yesContinue")) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _c("div", { attrs: { slot: "buttons" }, slot: "buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeAwardSuccessModal()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("action.ok")) + "\n      "
                    ),
                  ]
                ),
              ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }